import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import SideBlock from './SideBlock';
import './SideBar.scss';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const EMPTY_NOTES_COUNT = 4;

const EMPTY_NOTES_SECTION = (
    <>
        {Array.from(Array(EMPTY_NOTES_COUNT)).map((i, index) => (
            <div key={generateReactKey(index, i)} className="notes-lines" />
        ))}
    </>
);

const SideBar = ({ notes, statusSection, legend }) => (
    <div className="side-bar">
        {statusSection}
        {notes && (
            <SideBlock
                title="Notes"
                content={
                    isEmpty(notes) ? (
                        EMPTY_NOTES_SECTION
                    ) : (
                        <div>
                            {notes.map((note, index) => (
                                <Fragment key={generateReactKey(index)}>
                                    {note}
                                    <br />
                                </Fragment>
                            ))}
                        </div>
                    )
                }
            />
        )}
        {legend && <SideBlock title="Legend" content={legend} />}
    </div>
);

SideBar.defaultProps = {
    notes: null,
    statusSection: null,
    legend: null,
};

SideBar.propTypes = {
    notes: PropTypes.array,
    statusSection: PropTypes.object,
    legend: PropTypes.object,
};

export default SideBar;
